export default defineNuxtPlugin((nuxtApp) => {
    const HOTJAR_ID = 2534830
    const HOTJAR_VERSION = 6
    let isHotjarLoaded = false

    const loadHotjar = () => {
      if (isHotjarLoaded) return;

      ;(function(h: any,o: any,t: any,j: any,a?: any,r?: any){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}
        h._hjSettings={hjid: HOTJAR_ID, hjsv: HOTJAR_VERSION}
        a=o.getElementsByTagName('head')[0]
        r=o.createElement('script')
        r.async=1
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv
        a.appendChild(r)
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')

      isHotjarLoaded = true
    }

    const loadHotJarWithDelay = () => {
        if (process.client) {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

            if (isMobile) {
                // For mobile: Load on first touch
                document.addEventListener('touchstart', () => {
                loadHotjar()
                }, { once: true })
            } else {
                // For desktop: Load on mousemove
                document.addEventListener('mousemove', () => {
                loadHotjar()
                }, { once: true })
            }
        }
    }

    // Initialize when app is mounted
    nuxtApp.hook('app:mounted', () => {
        loadHotJarWithDelay();
    });
})